import React from 'react';
import Navbar from '../components/Navbar/Navbar';
import Hero from '../components/Hero/Hero';
import Products from '../components/Products/Products';
import TyreFinder from '../components/TyreFinder/TyreFinder';
import AboutUs from '../components/AboutUs/AboutUs';
import Services from '../components/Services/Services';
import Contact from '../components/Contact/Contact';
import Footer from '../components/Footer/Footer';

const HomePage = () => {
  return (
    <div>
      <Navbar />
      <section id="home"><Hero /></section>
      <section id="products"><Products /></section>
      <section id="finder"><TyreFinder /></section>
      <section id="about"><AboutUs /></section>
      <section id="services"><Services /></section>
      <section id="contact"><Contact /></section>
      <Footer />
    </div>
  );
};

export default HomePage;